import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { CreateAccountStage } from 'features/CreateAccount/hooks/useGoToCreateAccountStage/useGoToCreateAccountStage.types'

const CREATE_ACCOUNT_STAGES = Object.values(CreateAccountStage)

interface CreateAccountState {
  CreateAccountModal: { stage: CreateAccountStage } | undefined
}

export const useCreateAccountStage = () => {
  const location = useLocation<CreateAccountState | undefined>()

  const stage = useMemo(() => {
    if (
      !location.state?.CreateAccountModal?.stage ||
      !CREATE_ACCOUNT_STAGES.includes(location.state.CreateAccountModal.stage)
    ) {
      return null
    }

    return location.state.CreateAccountModal.stage
  }, [location.state?.CreateAccountModal?.stage])

  return { stage }
}
